/** Profile opt-in flag (Settings → Feature Flags). */
export const UPTIME_TAB_FEATURE_FLAG = 'uptime-tab';

export const uptimeTabFeatureFlag = {
  name: UPTIME_TAB_FEATURE_FLAG,
  pluginId: 'app',
  description:
    'Show the Uptime tab in the sidebar. Preview of Checkly-backed service status (status.inv.tech).',
};

export const JIRA_BOARDS_TAB_FEATURE_FLAG = 'jira-boards-tab';

export const jiraBoardsTabFeatureFlag = {
  name: JIRA_BOARDS_TAB_FEATURE_FLAG,
  pluginId: 'app',
  description: 'Show Jira Boards as a standalone sidebar tab.',
};

export const ORGANIZATION_TAB_FEATURE_FLAG = 'organization-tab';

export const organizationTabFeatureFlag = {
  name: ORGANIZATION_TAB_FEATURE_FLAG,
  pluginId: 'app',
  description: 'Show Organization in the sidebar. Preview of team-to-board mappings.',
};
